@if (items().length) {
    <div class="flex flex-col gap-6">
        @for (item of items(); track item) {
            <div class="flex flex-row gap-2 items-start max-w-[560px]">
                <div class="text-[24px] text-bold-green element-checked"></div>
                <p class="text-copy-l">{{ item | translate }}</p>
            </div>
        }
    </div>
}
